module.exports = __webpack_public_path__ + "static/img/IMG_20150910_224725.1b09a020.jpg";